export default "__VITE_ASSET__d9e2c911__"